import { AllCommentsProps } from "../../data-model/busniessOfficeNote";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

interface CommentRpaModalSavePayload {
  identifier: string;
  org_id?: string | null;
  bo_status?: string | null;
  overwrite_rpa_errors?: boolean;
  write_back_reports?: AllCommentsProps[] | null;
  auth_status?: string;
}

export const commentRpaModalSave = async (
  payload: CommentRpaModalSavePayload,
) => {
  try {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.COMMENT_RPA_MODAL_SAVE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
      );
    }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};
